const contexts = [
  { id: 'work', name: 'Work', icon: '💼', color: 'bg-blue-500' },
  { id: 'legal', name: 'Legal', icon: '⚖️', color: 'bg-purple-500' },
  { id: 'parenting', name: 'Parenting', icon: '👨‍👧', color: 'bg-green-500' },
  { id: 'personal', name: 'Personal', icon: '🏠', color: 'bg-yellow-500' },
  { id: 'health', name: 'Health', icon: '❤️', color: 'bg-red-500' },
  { id: 'finance', name: 'Finance', icon: '💰', color: 'bg-emerald-500' },
];

export function Contexts() {
  return (
    <div className="p-4 space-y-6">
      <header className="pt-2">
        <h1 className="text-2xl font-bold">Life Contexts</h1>
        <p className="text-white/50 text-sm">Your different areas of life</p>
      </header>

      <section className="space-y-3">
        {contexts.map((context) => (
          <div key={context.id} className="card flex items-center gap-4">
            <div className={`w-12 h-12 rounded-xl ${context.color} flex items-center justify-center text-2xl`}>
              {context.icon}
            </div>
            <div className="flex-1">
              <h3 className="font-medium">{context.name}</h3>
              <p className="text-white/50 text-sm">0 items</p>
            </div>
            <div className="text-white/30">›</div>
          </div>
        ))}
      </section>
    </div>
  );
}
